/* CBV Custom Overrides v2.1
   - Ajoute cartes DIMENSIONS dynamiques + spécificités par produit dans la fiche technique
   - Les cartes injectées CLONENT les cartes existantes pour avoir EXACTEMENT le même design
   - Logique rename retirée (à faire dans customizer Shopify)
   - v2.1 : OUVERTURE Intelligente reformulée pour clarté client
*/
(function() {
  'use strict';

  var PRODUCT_DATA = {
    'valise-cabine': { // Premium
      productName: 'Premium',
      dimensions: {
        '20 pouces': '55 × 40 × 20 cm',
        '24 pouces': '66,5 × 45,5 × 25,5 cm',
        '29 pouces': '78 × 50,5 × 29 cm'
      },
      extraSpecs: [
        { iconKey: 'shield', label: 'COQUE', value: 'Alliage aluminium-magnésium' },
        { iconKey: 'handle', label: 'POIGNÉE', value: 'Télescopique ergonomique' },
        { iconKey: 'gift', label: 'CONTENU', value: '1 valise + 1 notice' }
      ]
    },
    'valise-cabine-kono': { // KONO
      productName: 'KONO',
      dimensions: {
        '20 pouces': '55 × 40 × 20 cm',
        '24 pouces': '66,5 × 45,5 × 25,5 cm',
        '28 pouces': '76,5 × 50,5 × 29 cm'
      },
      extraSpecs: [
        { iconKey: 'shield', label: 'COQUE', value: 'Polycarbonate (PC) rigide' },
        { iconKey: 'handle', label: 'POIGNÉE', value: 'Télescopique aluminium' },
        { iconKey: 'gift', label: 'CONTENU', value: '1 valise + 1 notice' }
      ]
    },
    'valise-cabine-cabinova': { // Gobelet / Intelligente
      productName: 'Intelligente',
      dimensions: {
        '20 pouces': '55 × 40 × 20 cm',
        '24 pouces': '66,5 × 45,5 × 25,5 cm'
      },
      extraSpecs: [
        { iconKey: 'shield', label: 'COQUE', value: 'ABS + cadre aluminium' },
        { iconKey: 'cup', label: 'PORTE-GOBELET', value: 'Rétractable intégré' },
        { iconKey: 'usb', label: 'PORT USB', value: 'Intégré (batterie non incluse)' },
        { iconKey: 'open', label: 'OUVERTURE', value: 'Poche avant + ouverture complète' }
      ]
    }
  };

  // Material icons codes par sigle
  var ICON_MAP = {
    'ruler': 'straighten',
    'shield': 'inventory_2',
    'handle': 'pan_tool',
    'gift': 'card_giftcard',
    'cup': 'local_cafe',
    'usb': 'usb',
    'open': 'open_in_new'
  };

  function getProductHandle() {
    var path = location.pathname || '';
    var m = path.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function findFicheTechniqueContainer() {
    var els = document.querySelectorAll('details summary, .accordion__title, [class*="accordion"] [class*="title"], button[aria-expanded]');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || '').toUpperCase().trim();
      if (t.indexOf('FICHE TECHNIQUE') !== -1) {
        var details = els[i].closest('details') || els[i].parentElement;
        if (details) return details;
      }
    }
    return null;
  }

  function findExistingCards(container) {
    var candidates = [
      container.querySelectorAll('[class*="icon-with-text"]'),
      container.querySelectorAll('[class*="spec-card"]'),
      container.querySelectorAll('[class*="feature-card"]'),
      container.querySelectorAll('[class*="card"]')
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i].length >= 2) return candidates[i];
    }
    return null;
  }

  function cloneAndAdaptCard(originalCard, newIcon, newLabel, newValue, dataAttrs) {
    var clone = originalCard.cloneNode(true);
    if (dataAttrs) {
      Object.keys(dataAttrs).forEach(function(k){ clone.setAttribute(k, dataAttrs[k]); });
    }

    var iconEl = clone.querySelector('.material-icons, [class*="material-icon"], .icon, svg, [class*="-icon"]');
    if (iconEl) {
      if (iconEl.classList.contains('material-icons') || iconEl.tagName === 'SPAN') {
        iconEl.textContent = newIcon;
      } else if (iconEl.tagName === 'SVG' || iconEl.tagName === 'IMG') {
        var newSpan = document.createElement('span');
        newSpan.className = 'material-icons';
        newSpan.textContent = newIcon;
        var cs = window.getComputedStyle(iconEl);
        newSpan.style.color = cs.color || '#c08749';
        newSpan.style.fontSize = '24px';
        iconEl.replaceWith(newSpan);
      }
    }

    var labelCandidates = clone.querySelectorAll('[class*="label"], [class*="title"], [class*="text"], p, h3, h4, h5, h6, span, strong');
    var labelSet = false;
    var valueSet = false;
    for (var i = 0; i < labelCandidates.length; i++) {
      var el = labelCandidates[i];
      if (el === iconEl || (iconEl && iconEl.contains(el))) continue;
      var txt = (el.textContent || '').trim();
      if (!txt) continue;
      if (!labelSet && (txt === txt.toUpperCase() || txt.length < 20)) {
        if (el.children.length === 0 || (el.children.length === 1 && el.children[0].tagName === 'SPAN')) {
          el.textContent = newLabel;
          labelSet = true;
          continue;
        }
      }
      if (!valueSet && labelSet) {
        if (el.children.length === 0 || (el.children.length === 1 && el.children[0].tagName === 'SPAN')) {
          el.textContent = newValue;
          valueSet = true;
          continue;
        }
      }
    }

    if (!labelSet || !valueSet) {
      var texts = clone.querySelectorAll('p, span, [class*="text"]');
      var found = 0;
      for (var j = 0; j < texts.length; j++) {
        if (texts[j].closest && texts[j].closest('[class*="icon"]')) continue;
        var t = (texts[j].textContent || '').trim();
        if (!t || texts[j].children.length > 1) continue;
        if (found === 0) { texts[j].textContent = newLabel; found++; }
        else if (found === 1) { texts[j].textContent = newValue; found++; break; }
      }
    }

    return clone;
  }

  function injectSpecs() {
    var handle = getProductHandle();
    if (!handle) return false;
    var data = PRODUCT_DATA[handle];
    if (!data) return false;

    var container = findFicheTechniqueContainer();
    if (!container) return false;
    if (container.dataset.cbvSpecsInjected === 'true') return true;

    var existingCards = findExistingCards(container);
    if (!existingCards || existingCards.length < 1) return false;

    var firstCard = existingCards[0];
    var parentGrid = firstCard.parentElement;
    if (!parentGrid) return false;

    container.dataset.cbvSpecsInjected = 'true';

    var sizes = Object.keys(data.dimensions);
    var currentSize = sizes[0];
    var dimCard = cloneAndAdaptCard(firstCard, ICON_MAP.ruler, 'DIMENSIONS', data.dimensions[currentSize], { 'data-cbv-dim-card': 'true' });
    parentGrid.appendChild(dimCard);

    data.extraSpecs.forEach(function(spec) {
      var iconUnicode = ICON_MAP[spec.iconKey] || 'check_circle';
      var card = cloneAndAdaptCard(firstCard, iconUnicode, spec.label, spec.value, null);
      parentGrid.appendChild(card);
    });

    function updateDimension(size) {
      if (!size || !data.dimensions[size]) return;
      var texts = dimCard.querySelectorAll('p, span, [class*="text"]');
      var labelFound = false;
      for (var i = 0; i < texts.length; i++) {
        if (texts[i].closest && texts[i].closest('[class*="icon"]')) continue;
        var t = (texts[i].textContent || '').trim();
        if (!t || texts[i].children.length > 1) continue;
        if (t === 'DIMENSIONS' || t.toUpperCase() === 'DIMENSIONS') {
          labelFound = true;
          continue;
        }
        if (labelFound) {
          texts[i].textContent = data.dimensions[size];
          break;
        }
      }
    }

    function detectSizeFromForm() {
      var sels = document.querySelectorAll('select[name*="taille" i], select[name*="size" i], select[name*="option" i]');
      for (var i = 0; i < sels.length; i++) {
        var v = sels[i].value;
        if (data.dimensions[v]) return v;
      }
      var pressed = document.querySelectorAll('[aria-pressed="true"], [data-selected="true"], input[type="radio"]:checked');
      for (var j = 0; j < pressed.length; j++) {
        var t = (pressed[j].textContent || pressed[j].value || '').trim();
        if (data.dimensions[t]) return t;
        if (pressed[j].id) {
          var lab = document.querySelector('label[for="' + pressed[j].id + '"]');
          if (lab) {
            var lt = (lab.textContent || '').trim();
            if (data.dimensions[lt]) return lt;
          }
        }
      }
      return null;
    }

    function onVariantChange() {
      var size = detectSizeFromForm();
      if (size) updateDimension(size);
    }

    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('shopify:variant:change', onVariantChange);
    document.addEventListener('change', function(e) {
      if (!e.target) return;
      var name = (e.target.name || '').toLowerCase();
      var id = (e.target.id || '').toLowerCase();
      if (/option|variant|size|taille/.test(name + ' ' + id)) {
        setTimeout(onVariantChange, 60);
      }
    });
    document.addEventListener('click', function(e) {
      if (!e.target) return;
      var label = e.target.closest && e.target.closest('label, button[role="radio"], [data-option-value]');
      if (label) {
        var t = (label.textContent || '').trim();
        if (data.dimensions[t]) setTimeout(function(){ updateDimension(t); }, 80);
      }
    });

    setTimeout(onVariantChange, 200);
    return true;
  }

  function init() {
    try {
      var ok = injectSpecs();
      if (!ok) {
        setTimeout(injectSpecs, 800);
        setTimeout(injectSpecs, 2000);
      }
    } catch(e) { console.warn('[CBV] inject specs failed', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function(){ setTimeout(init, 300); });

  if ('MutationObserver' in window) {
    var retried = false;
    var obs = new MutationObserver(function(){
      if (retried) return;
      var c = findFicheTechniqueContainer();
      if (c && c.dataset.cbvSpecsInjected !== 'true') {
        retried = true;
        setTimeout(function(){ retried = false; init(); }, 400);
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();
